import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import ContactsOutlinedIcon from '@mui/icons-material/ContactsOutlined';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import InventoryIcon from '@mui/icons-material/Inventory';
import BallotIcon from '@mui/icons-material/Ballot';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import GavelIcon from '@mui/icons-material/Gavel';
import Groups3Icon from '@mui/icons-material/Groups3';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import EmailIcon from '@mui/icons-material/Email';

export const searchResultMap = {
  companies: {
    label: 'Companies',
    Icon: ApartmentOutlinedIcon,
    to: '/companies/',
    path: 'companies',
  },
  contacts: {
    label: 'Contacts',
    Icon: ContactsOutlinedIcon,
    to: '/contacts/',
    path: 'contacts',
  },
  contracts: {
    label: 'Contracts',
    Icon: GavelIcon,
    to: '/contracts/',
    path: 'contracts',
  },
  //files: { label: "Files", Icon: FolderOutlinedIcon },
  invoices: {
    label: 'Invoices',
    Icon: ReceiptOutlinedIcon,
    to: '/invoices/',
    path: 'invoices',
  },
  offers: {
    label: 'Offers',
    Icon: DescriptionOutlinedIcon,
    to: '/offers/',
    path: 'offers',
  },
  orders: { label: 'Orders', Icon: BallotIcon, to: '/orders/', path: 'orders' },
  products: {
    label: 'Products',
    Icon: InventoryIcon,
    to: '/products/',
    path: 'products',
  },
  projects: {
    label: 'Projects',
    Icon: AccountTreeOutlinedIcon,
    to: '/projects/management/',
    path: 'projects',
  },
  services: {
    label: 'Services',
    Icon: SupervisedUserCircleIcon,
    to: '/services/',
    path: 'services',
  },
  users: {
    label: 'Employees',
    Icon: PeopleOutlinedIcon,
    to: '/employees/',
    path: 'users/reduced',
  },
  receipts: {
    label: 'Expenses',
    Icon: RequestQuoteIcon,
    to: '/expenses/receipts/',
    path: 'receipts',
  },
  dunning_processes: {
    label: 'Payment Reminder',
    Icon: NotificationsActiveIcon,
    to: '/payment-reminders/',
    path: 'dunning-processes',
  },
  company_leads: {
    label: 'Company Leads',
    Icon: Groups3Icon,
    to: '/leads/companies/',
    path: 'leads/companies',
  },
  person_leads: {
    label: 'Person Leads',
    Icon: Groups3Icon,
    to: '/leads/persons/',
    path: 'leads/persons',
  },
  /*imap_emails: {
    label: 'Emails',
    Icon: EmailIcon,
    to: '/emails/',
    path: 'emails',
  },*/
};
